import moment from 'moment';

export const toResolutionKey = (resolution: any): string => {
  return resolution.days + '_' + resolution.hourly;
};

export const isNight = (dtg: string): boolean => {
  return moment(dtg).utc().hours() === 6;
};

export const isHiddenParameter = (
  parameter: string,
  userParameters: any,
  resolution: any,
  parameterDefinitions: any
): boolean => {
  if (parameter === 'dtg' || parameter === 'dayNight') {
    return false;
  }
  if (
    !isParameterAvailableForResolution(
      parameter,
      resolution,
      parameterDefinitions
    )
  ) {
    return true;
  }
  for (const userParameter of userParameters) {
    if (userParameter.parameter === parameter) {
      return !userParameter.selected;
    }
  }
  return true;
};

export const isParameterAvailableForResolution = (
  parameter: string,
  resolution: any,
  parameterDefinitions: any
): boolean => {
  const hourly = resolution.hourly;
  return (
    parameterDefinitions?.some(
      p => parameter === p.fe_parameter && hourly === p.hourly
    ) ?? false
  );
};

export const parameterGroupColor = (parameter: string): string => {
  if (parameter.indexOf('_rst_min') > 0 || parameter.indexOf('_tn') > 0) {
    return 'tn';
  }
  if (parameter.indexOf('_rst_max') > 0 || parameter.indexOf('_tx') > 0) {
    return 'tx';
  }
  return null;
};

export const parameterColor = (parameter: string): string => {
  const parametersWithClasses = [
    'tx',
    'tn',
    'i_he',
    'i_gm',
    'i_hr',
    'i_lr',
    'i_st',
    'i_th',
    'i_uv',
    'i_sl',
    'i_sl_wing',
    'i_co',
    'i_ld',
    'i_di',
    'i_gp',
    'i_gc',
    'i_ein',
    'i_pi',
    'i_he_pi',
    'i_co_pi',
    'i_th_pi',
    'i_rr_pi',
    'i_ff_pi',
    'i_hu_pi',
    'i_fo_pi',
    'i_hfo_pi',
    'i_ne_pi',
    'i_nl_pi',
    'i_nm_pi',
    'i_nh_pi',
    'i_isn',
    'i_blade_ice',
    'i_fg',
    'i_hw',
    'i_the',
    'i_dust',
    'i_sp_snow',
  ];
  if (parametersWithClasses.indexOf(parameter) >= 0) {
    return 'parameter-color-' + parameter;
  }
  const color = parameterGroupColor(parameter);
  if (color) {
    return 'parameter-color-' + color;
  }
  return '';
};

export const colorMappingSnow = (
  value: number,
  greenTableDesign: boolean
): string => {
  let color = greenTableDesign ? 'table-green' : '';

  if (!value) {
    return color;
  }
  if (value >= 0.001) {
    color = 'table-danger';
  }

  return color;
};

export const isWindpowerStation = (stationId: number) => {
  if (stationId > 3400000 && stationId < 3500000) return true;
  if (stationId > 103400000 && stationId < 103500000) return true;
  if (stationId > 903400000 && stationId < 903500000) return true;
  return false;
};

export const isSolarpowerStation = (stationId: number) => {
  if (stationId > 3500000 && stationId < 3600000) return true;
  if (stationId > 103500000 && stationId < 103600000) return true;
  if (stationId > 903500000 && stationId < 903600000) return true;
  return false;
};

export const parameterClass = (parameter: string): string => {
  const coloredTemperatureParameters = [
    'tt',
    'road_rst',
    'bridge_rst',
    'bike_rst',
    'foot_rst',
    'blade_rst',
    'panel_rst',
    'tx',
    'tn',
    'rail_tt',
    'rail_tx',
    'rail_tn',
    'overhead_tt',
    'overhead_tx',
    'overhead_tn',
    'wing_rst',
    'tt_F',
    'road_rst_F',
    'bridge_rst_F',
    'bike_rst_F',
    'foot_rst_F',
    'tx_F',
    'tn_F',
    'rail_tt_F',
    'rail_tx_F',
    'rail_tn_F',
    'overhead_tt_F',
    'overhead_tx_F',
    'overhead_tn_F',
    'wing_rst_F',
  ];
  if (
    coloredTemperatureParameters.indexOf(parameter) >= 0 ||
    parameter.indexOf('_rst_') > 0
  ) {
    return 'tt_color';
  } else if (
    parameter.indexOf('tt') >= 0 ||
    parameter.indexOf('tg') >= 0 ||
    parameter.indexOf('td') >= 0
  ) {
    return 'tt';
  }
  if (parameter.indexOf('i_') === 0) {
    return 'index';
  }
  // parameter === 'wwc' || parameter === 'wwp' || parameter === 'wwt'
  const possibilityParameters = [
    'wwc',
    'wwp',
    'wwt',
    'wws',
    'wwf',
    'wwd',
    'ww_blade_ice',
    'pwwhw',
    'pwwsp',
    'pwdust',
  ];
  if (possibilityParameters.indexOf(parameter) >= 0) {
    return 'possibility';
  }
  // condition
  const conditionParameters = [
    'road_rsc',
    'bridge_rsc',
    'bike_rsc',
    'foot_rsc',
    'rail_condition',
    'overhead_condition',
    'wing_rsc',
    'blade_rsc',
    'panel_rsc',
  ];
  if (conditionParameters.indexOf(parameter) >= 0) {
    return 'condition';
  }

  // wind (kn)
  const windKnParameters = [
    'ff_kn',
    'ffx_kn',
    'ff50_kn',
    'ffx50_kn',
    'ff100_kn',
    'ffx100_kn',
  ];
  if (windKnParameters.indexOf(parameter) >= 0) {
    return 'ff_kn';
  }
  return '';
};
